module.exports = __webpack_public_path__ + "static/media/enhanced.83e67627.webp";